/**
 * Idenfities specific teaching moments (e.g., showing bubble illustrating a feature).
 * Expected to be triggered within timestream, but consumers may be external to timestream
 */
export enum TeachingMomentId {
    AddWidget,
    ShortcutKeys,
    PinFile,
}
